import styled, { mediaQuery, theme, css } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2, H5 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MARIGOLD } from 'HubStyleTokens/colors';
import { NUMBER_OF_USERS_CERTIFIED } from 'academy-common-lib/constants/general';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import usageTracker from '../../utils/usageTracker';
import StyledSection from '../publicLayout/components/StyledSection';
import { Link } from 'react-router-dom';
import { ThemedLinkMixin, ThemedPrimaryRouterButton } from '../../components/ThemedComponents';
import { getLocationDescriptor } from '../../utils/routing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRouterLink = styled(Link).withConfig({
  displayName: "CertificationsSection__StyledRouterLink",
  componentId: "sc-1n7n8x3-0"
})(["", ""], ThemedLinkMixin);
const CertificatesContainer = styled.div.withConfig({
  displayName: "CertificationsSection__CertificatesContainer",
  componentId: "sc-1n7n8x3-1"
})(["display:flex;flex-wrap:nowrap;column-gap:20px;row-gap:40px;margin-top:100px;", " & > *{flex:0 1;flex-basis:calc(50% - 10px);", "}"], mediaQuery('tablet', css(["flex-wrap:wrap;"])), mediaQuery('mobile', css(["flex-basis:100%;"])));
const CertificateLinkCard = ({
  iconColor,
  title,
  description,
  href,
  to
}) => {
  const handleCertificationClick = () => {
    usageTracker.track('interaction', {
      action: 'certification-link-click',
      href
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(StyledRouterLink, {
      className: "display-block m-bottom-2",
      onClick: handleCertificationClick,
      to: getLocationDescriptor(to),
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          color: iconColor
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "certification",
          size: 50
        })
      }), title]
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
const CertificationsSection = () => {
  const handleViewAllClick = () => {
    usageTracker.track('interaction', {
      action: 'view-all-certifications-click'
    });
  };
  return /*#__PURE__*/_jsx(StyledSection, {
    className: "text-center",
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificationsSection.title"
        })
      }), /*#__PURE__*/_jsx(H5, {
        className: "m-bottom-15",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificationsSection.description",
          options: {
            count: NUMBER_OF_USERS_CERTIFIED
          }
        })
      }), /*#__PURE__*/_jsxs(CertificatesContainer, {
        className: "m-bottom-10",
        children: [/*#__PURE__*/_jsx(CertificateLinkCard, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.inboundDescription"
          }),
          href: getProxyUrl('/courses/inbound'),
          iconColor: theme.colors.LORAX,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.inbound"
          }),
          to: '/courses/inbound'
        }), /*#__PURE__*/_jsx(CertificateLinkCard, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.socialMediaDescription"
          }),
          href: getProxyUrl('/courses/social-media'),
          iconColor: theme.colors.OZ,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.socialMedia"
          }),
          to: '/courses/social-media'
        }), /*#__PURE__*/_jsx(CertificateLinkCard, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.emailMarketingDescription"
          }),
          href: getProxyUrl('/courses/email-marketing'),
          iconColor: theme.colors.CANDY_APPLE,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.emailMarketing"
          }),
          to: '/courses/email-marketing'
        }), /*#__PURE__*/_jsx(CertificateLinkCard, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.contentMarketingDescription"
          }),
          href: getProxyUrl('/courses/content-marketing'),
          iconColor: MARIGOLD,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.contentMarketing"
          }),
          to: '/courses/content-marketing'
        }), /*#__PURE__*/_jsx(CertificateLinkCard, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.inboundSalesDescription"
          }),
          href: getProxyUrl('/courses/inbound-sales'),
          iconColor: theme.colors.EERIE,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsSection.inboundSales"
          }),
          to: '/courses/inbound-sales'
        })]
      }), /*#__PURE__*/_jsx(ThemedPrimaryRouterButton, {
        onClick: handleViewAllClick,
        to: '/courses?awardType=ONLY_SHOW_CERTIFICATE_COURSES',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificationsSection.viewAll"
        })
      })]
    })
  });
};
export default CertificationsSection;